<template>
  <v-alert
    id="alert-error"
    type="error"
    dark
    icon="mdi-alert-circle"
    border="left"
    prominent
    :value="!!error.name"
    transition="fade-transition"
    dismissible
    dense
    data-test-id="error"
    @input="clearError"
  >
    <v-expansion-panels class="min-h">
      <v-expansion-panel style="flex-basis: auto">
        <v-expansion-panel-header :data-test-id="$tid('error', 'panel-header')">{{
          error.name
        }}</v-expansion-panel-header>
        <v-expansion-panel-content :data-test-id="$tid('error', 'message')">
          {{ error.message }}
          <div v-if="error.debugInfo" class="text-pre-wrap" :data-test-id="$tid('error', 'debug-info')">
            {{ error.debugInfo }}
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-alert>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useErrorStore } from '@/store/stores';

export default defineComponent({
  name: 'Error',
  computed: {
    ...mapState(useErrorStore, ['error']),
  },
  methods: {
    ...mapActions(useErrorStore, ['clearError']),
  },
});
</script>
<style lang="sass">
.v-alert__content
  z-index: 9999!important
.min-h
  min-width: 290px!important
#alert-error
  position: fixed
  min-width: 300px
  bottom: 20px
  right: 10px
  z-index: 999!important
.theme--dark.v-expansion-panels .v-expansion-panel
  background-color: rgba(0, 0, 0, 0) !important
</style>
